import { useEffect } from 'react';
import { useState } from 'react';
import { Container, IconButton,  Typography, Tooltip, Tab } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSelector } from 'src/reducers';
import { DataGridRender } from 'src/components/table';
import { ProjectReportsRequest,  ProjectExportRequest, ProjectResetSuccess, ProjectGroupExportRequest, ProjectPreScreenRequest, ProjectPrescreenReportsRequest } from 'src/actions/projectActions';
import { Download } from '@mui/icons-material';
import TabLayout from 'src/components/tab/TabLayout';
import TopBar from 'src/components/shared/TopBar';
import { projectActionTypes } from 'src/types/actionTypes';

export default function ProjectReport() {

  const [tabValue, setTabValue] = useState(1);
  const [pageNo, setPageNo] = useState(1);
  const [limit, setLimit] = useState(10);
  const [filters, setFilters] = useState<any>({});
  const [ filterTypes ,setFilterTypes] = useState<any>(['dateRange', 'export','client'])
  const dispatch = useDispatch();
  const { project, reportProjects } = useSelector(state => state.project);

  useEffect(() => {
    if (Object.keys(filters).length) {
      dispatch(ProjectReportsRequest(filters ,{}));
    }
    else{
      dispatch(ProjectResetSuccess({}));
    }
  }, [filters]);

  const exportAction = (id: string, projectName: string) => {
    if(tabValue == 1) dispatch(ProjectGroupExportRequest({ projectId: id }, projectName));
    if(tabValue == 2) dispatch(ProjectGroupExportRequest({ projectId: id }, projectName));
  }

  const columns = [
    {
      field: 'projectCode', type: "string", headerName: 'Project #', filterable: false, headerAlign: "center", align: 'center', width: 150, pinnable: true, renderCell: ({ id, value }: any) => {
        return <Typography color="primary" >{value}</Typography>
      }
    },
    {
      field: 'projectName', type: "string", headerName: 'Project Title', filterable: false, headerAlign: "left", align: 'left', flex: 1, renderCell: ({ id, value }: any) => {
        return <Tooltip title={value}>
          <Typography variant="subtitle2">{value}</Typography>
        </Tooltip>
      }
    },
    { field: 'complete', type: "string", headerName: 'Complete', filterable: false, headerAlign: "center", align: 'center', flex: 1 },
    { field: 'terminate', type: "string", headerName: 'Terminate', filterable: false, headerAlign: "center", align: 'center', flex: 1 },
    { field: 'qualityTerm', type: "string", headerName: 'Quality Terminate', filterable: false, headerAlign: "center", align: 'center', width: 150 },
    { field: 'overQuota', type: "string", headerName: 'Over Quota', filterable: false, headerAlign: "center", align: 'center', flex: 1 },
    { field: 'clicked', type: "string", headerName: 'Traffic', filterable: false, headerAlign: "center", align: 'center', flex: 1 },
    { field: 'totalDisqualified', type: "string", headerName: 'Disqualified', filterable: false, headerAlign: "center", align: 'center', flex: 1 },
    { field: 'drop', type: "string", headerName: 'Dropped', filterable: false, headerAlign: "center", align: 'center', flex: 1 },
    {
      field: 'isActive', headerName: '', headerAlign: "center", align: 'center', disableExport: true, type: "boolean", width: 80, renderCell: ({ row }: any) => {
        return <IconButton onClick={() => exportAction(row._id, row['projectCode'] + "_" + row['projectName'])}>
          <Download />
        </IconButton>
      }
    },
  ];

  const handleChange = (event: React.SyntheticEvent, value: number) =>{ 
    setTabValue(value);
    setFilters({});
    dispatch({ type:projectActionTypes.FETCH_REPORT_PROJECT_SUCCESS, payload: { reportProjects:[], loading:false} });
    // if(value == 1) setFilterTypes(['dateRange', 'export','project']);
    if(value == 1)  setFilterTypes(['dateRange', 'export','client']);
    if(value == 2) setFilterTypes(['dateRange', 'export','supplier']);
    // if(value == 4) setFilterTypes(['dateRange', 'export','project']);
    // if(value == 5) setFilterTypes(['dateRange', 'export']);
   }


  return (
    <Container maxWidth={false}>
      <TopBar title="Reports" link="" buttonText="" />
      <TabLayout handleChange={handleChange} tabValue={tabValue}>
        {/* <Tab label="Project" value={1} /> */}
        <Tab label="Client" value={1} />
        <Tab label="Supplier" value={2} />
        {/* <Tab label="Prescreen" value={4} />
        <Tab label="Complete Allocated" value={5} /> */}
      </TabLayout>
      <DataGridRender
        filterTypes={filterTypes}
        data={reportProjects}
        metadata=""
        limit={limit}
        filters={filters}
        pageNo={pageNo}
        exportFileName={tabValue == 1 ? "Clients" : "Supplier" }
        columns={columns}
        setPageNo={setPageNo}
        setLimit={setLimit}
        setFilters={setFilters}
        hideFooterPagination={true}
      />
    </Container>
  );
}
